
function createLogger(name) {
  return {
    info: console.log.bind(null, `[${name}]`),
    error: console.error.bind(null, `[${name}]`),
    debug: console.debug.bind(null, `[${name}]`),
  }
}


export default createLogger;



// WEBPACK FOOTER //
// ./src/utils/logger.js